import Grid from '../components/grid'
import Container from '../components/ui/container'
import Text from '../components/ui/text'
import { Asset } from '../v2/components/Asset'
import { Page, Asset as AssetType } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'

export type BlockProps = Extract<Page['blocks'][0], { blockType: 'info-column-image' }>

export default function InfoColumnImage(block: BlockProps): ReactElement {
  const { title, description, image, cluster, imageInfo } = block

  return (
    <Container>
      <Grid className="bg-accent-1 p-8 md:p-12 lg:p-20">
        <div className="col-span-full md:col-span-4 lg:col-span-8 text-heading xl:mb-8">
          <Text variant="subHeading" className="max-w-2xl">
            {title}
          </Text>
        </div>

        <div className="relative col-span-full md:col-span-4 md:row-span-2">
          <div className="absolute inset-0 bg-telesoft bottom-12 md:bottom-0 mix-blend-soft-light z-10" />

          <div className="col-span-full relative min-h-[300px] mb-10 md:h-full">
            <Asset resource={image as AssetType} imgClassName="object-cover object-top" fill />
            <div className="absolute -bottom-12 right-0 z-10 flex flex-col justify-start items-end text-right">
              <h5>{imageInfo.title}</h5>
              <span className="text-xs uppercase mt-1">{imageInfo.subTitle}</span>
            </div>
          </div>
        </div>

        <div className="col-span-full md:col-span-4 lg:col-span-4 flex flex-col justify-start items-start">
          <h5 className="mb-2 text-black">{cluster.title}</h5>
          <Text>{cluster.description}</Text>
        </div>

        <div className="col-span-full lg:col-span-4 md:mt-10 lg:mt-7 xl:mr-8">
          <Text className="text-black">{description}</Text>
        </div>
      </Grid>
    </Container>
  )
}
